import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ReportsRouteModule } from './reports-route.module';
import { ChartsComponent } from './charts/charts.component';
import { CandTestScheduleComponent } from '../reports/cand-test-schedule/cand-test-schedule.component';
import { ExamStatusComponent } from '../reports/exam-status/exam-status.component';
import { QuesAnalysisComponent } from '../reports/ques-analysis/ques-analysis.component';
import { CandResLogComponent } from '../reports/cand-res-log/cand-res-log.component';
import { CandExamResComponent } from '../reports/cand-exam-res/cand-exam-res.component';
import { PrintScoreCardComponent } from '../reports/print-score-card/print-score-card.component';
import { ScoreComponent } from '../reports/score/score.component';
import { PerceWiseScoreComponent } from '../reports/perce-wise-score/perce-wise-score.component';
import { TopicWiseScoreComponent } from '../reports/topic-wise-score/topic-wise-score.component';
import { ViewQuesPaperComponent } from '../reports/view-ques-paper/view-ques-paper.component';
import { BulkDownloadComponent } from '../reports/view-ques-paper/bulk-download/bulk-download.component';
import { MarksheetComponent } from '../reports/marksheet/marksheet.component';
import { EventBasedLogComponent } from '../reports/event-based-log/event-based-log.component';
import { DayEndComponent } from '../reports/day-end/day-end.component';
import { ExamDurationComponent } from '../reports/exam-duration/exam-duration.component';
import { AnswerSheetComponent } from '../reports/answer-sheet/answer-sheet.component';
import { IdleCandidateComponent } from '../reports/idle-candidate/idle-candidate.component';
import { CandidateVerificationStatusComponent } from './candidate-verification-status/candidate-verification-status.component';
import { CandidateExamProgressComponent } from './candidate-exam-progress/candidate-exam-progress.component';
import { ReportsComponent } from '../reports/reports/reports.component';
import { BulkGenerationComponent } from '../reports/bulk-generation/bulk-generation.component';
import { BulkAuditTrailComponent } from '../reports/bulk-generation/bulk-audit-trail/bulk-audit-trail.component';
import { BulkCandResLogComponent } from '../reports/bulk-generation/bulk-cand-res-log/bulk-cand-res-log.component';
import { SharedModule } from "src/app/shared";
import { ReportHeaderComponent } from './report-header/report-header.component';
import { CandSeatsComponent } from './cand-seats/cand-seats.component';
import { CandidateBiometricsInlineComponent } from './candidate-verification-status/candidate-biometrics-inline/candidate-biometrics-inline.component';
import { DeviceListComponent } from './device-list/device-list.component';



@NgModule({
  declarations: [ChartsComponent,
    CandTestScheduleComponent,
    ExamStatusComponent,
    QuesAnalysisComponent,
    CandResLogComponent,
    CandExamResComponent,
    PrintScoreCardComponent,
    ScoreComponent,
    PerceWiseScoreComponent,
    TopicWiseScoreComponent,
    ViewQuesPaperComponent,
    BulkDownloadComponent,
    MarksheetComponent,
    EventBasedLogComponent,
    DayEndComponent,
    ExamDurationComponent,
    AnswerSheetComponent,
    IdleCandidateComponent,
    CandidateVerificationStatusComponent,
    CandidateExamProgressComponent,
    ReportsComponent,
    BulkGenerationComponent,
    BulkAuditTrailComponent,
    BulkCandResLogComponent,
    ReportHeaderComponent,
    CandSeatsComponent,
    CandidateBiometricsInlineComponent,
    DeviceListComponent,
    

  ],
  imports: [
    CommonModule,
    ReportsRouteModule,
    FormsModule,
    NgbModule,
    SharedModule
  ],
  exports: [ChartsComponent]
})
export class ReportsModule { }
